import { LEAD_SERVICES } from "../components/leads/leadUtils";

export const CLIENT_SERVICES = LEAD_SERVICES;
const DEV_SERVICES = ["Website", "App"];

export const AM_SLOT = { field: "assigned_account_manager", role: "account_manager", label: "Account Manager", testid: "cf-am-user" };
export const SOCIAL_SLOTS = [
  AM_SLOT,
  { field: "assigned_graphic_designer", role: "graphic_designer", label: "Graphic Designer", testid: "cf-gd-user" },
  { field: "assigned_content_writer", role: "content_writer", label: "Content Writer", testid: "cf-cw-user" },
  { field: "assigned_execution_specialist", role: "execution_specialist", label: "Execution Specialist", testid: "cf-ex-user" },
];
export const PM_SLOT = { field: "assigned_project_manager", role: "project_manager", label: "Project Manager", testid: "cf-pm-user" };

// Legacy clients (created before services existed) were all social media accounts.
export const servicesOf = (c) => (c?.services?.length ? c.services : ["Social Media"]);
export const hasSocial = (c) => servicesOf(c).includes("Social Media");
export const hasDev = (c) => servicesOf(c).some((s) => DEV_SERVICES.includes(s));

export function teamPlan(services = []) {
  const social = services.includes("Social Media");
  const dev = services.some((s) => DEV_SERVICES.includes(s));
  const needsAm = social || services.some((s) => s !== "Social Media" && !DEV_SERVICES.includes(s));
  const slots = social ? SOCIAL_SLOTS : needsAm ? [AM_SLOT] : [];
  return { social, dev, slots };
}

export const canSeeCosts = (user) => ["admin", "coo", "ceo"].includes(user?.role);
export const billingOf = (c, s) => (c?.service_billing?.[s] === "one_time" ? "one_time" : "monthly");

// Retainer per service: { service: { currency: amount } }, for the given billing type.
// Clients without a per-service breakdown count fully (as monthly) under their only service, otherwise as "Unallocated".
export function revenueByService(clients = [], billing = "monthly") {
  const out = {};
  const add = (svc, cur, amt) => {
    if (!amt) return;
    out[svc] = out[svc] || {};
    out[svc][cur] = (out[svc][cur] || 0) + amt;
  };
  for (const c of clients) {
    const cur = c.currency || "USD";
    const split = Object.entries(c.service_retainers || {}).filter(([, v]) => Number(v) > 0);
    if (split.length) split.forEach(([s, v]) => { if (billingOf(c, s) === billing) add(s, cur, Number(v)); });
    else if (billing === "monthly") {
      const svcs = servicesOf(c);
      add(svcs.length === 1 ? svcs[0] : "Unallocated", cur, Number(c.monthly_retainer) || 0);
    }
  }
  return out;
}
